'use strict';

const Action = require('./Action');

/**
 * Clase de gestión de una regla de tipo Deshabilitar variable
 *
 * @extends {Structure.Action}
 *
 * @memberOf Structure
 */
class DisableAction extends Action {
    /**
     * @inheritDoc
     */
    constructor(rawAction) {
        super(rawAction);

        this.type = Action.Types.DISABLE;
        this.function = 'disableField';
    }
}

module.exports = DisableAction;
